<template>
  <div class="ll-license-list">
    <div class="ll-license-list__title-line">
      <img
        v-if="iconImg"
        :src="iconImg"
        alt=""
        class="icon-img"
      >
      <div class="title">
        {{ title }}
      </div>
    </div>
    <div class="ll-license-list__content">
      <DotLoading v-if="isLoading||isloading" />
      <p v-else-if="itemList.length === 0 && !isLoading&&!isloading">
        {{ emptyText }}
      </p>
      <LlLicenseListCard
        v-for="(item, index) in itemList"
        v-else
        :key="index"
        :name="item.name"
        :item-list="item.licensesList"
        :empty-text="emptyText"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: "LlLicenseList",
  props: {
    iconImg: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    emptyText: {
      type: String,
      default: "",
    },
    subclass: {
      type: Array,
      default() {
        return [];
      },
    },
    itemList: {
      type: Array,
      default() {
        return [];
      },
    },
    isloading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    isLoading: false,
  }),
  methods: {
    $_loadingOpen() {
      this.isLoading = true;
    },
    $_loadingClose() {
      this.isLoading = false;
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/ll-license-list.scss";
</style>